export default __webpack_public_path__ + "static/media/vip-5.f973bd23.webp";